import sortBy from 'lodash-es/sortBy';
import { IState } from '..';
import { IOption } from '../../components/Select';
import { IAddressType, IStateLookup } from '../lookups';
import { IAddress } from './addressInterfaces';

export function getAddress(state: IState, id: number): IAddress {
  if (id > 0) {
    return state.address.hash[id];
  }

  return createNewAddress();
}

export function getAddressTypes(state: IState): IAddressType[] {
  const { ids, hash } = state.lookups.addressTypes;
  return sortBy(ids.map(id => ({ addressTypeId: id, type: hash[id] } as IAddressType)), (x: IAddressType) => x.type);
}

export function getStates(state: IState): IStateLookup[] {
  const { ids, hash } = state.lookups.states;
  return sortBy(ids.map(id => hash[id]), (x: IStateLookup) => x.name);
}

export function getStateOptions(state: IState, type: keyof IStateLookup): IOption[] {
  const { ids, hash } = state.lookups.states;
  return ids.map<IOption>(x => ({ label: hash[x].name, value: hash[x][type] }));
}

function createNewAddress(): IAddress {
  return {
    addressId: -1,
    addressTypeId: -1,
    city: '',
    primary: false,
    stateId: -1,
    street: '',
    street2: '',
    zipcode: ''
  };
}
